import { Link } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { useEffect, useState } from "react";
import './navigation.css';
import { fileMenus as fileMenusComponent } from '../../data/systemMenu/fileMenu';
import { usersAPI } from '../../api/usersAPI';
import { stockMenus as stockMenusComponent } from '../../data/systemMenu/stockMenu';

export default function Navigation({ logOut }) {
    const [fileMenu, setFileMenu] = useState([]);
    const [stockMenu, setStockMenu] = useState([]);

    const getSystemMenu = () => {
        usersAPI.getSystemMenusUserWise().
            then((data) => {
                setFileMenu(data.filter((item) => item.mainMenu === "Sales"));
                setStockMenu(data.filter((item) => item.mainMenu === "Stock"));
            });
    }

    const renderRoute = (subMenu, component) => {
        const allowedComponent = component.filter((data) => data.menuCode === subMenu.subMenuCode);

        if (allowedComponent.length === 1)
            return (<Route key={subMenu.subMenuCode} path={subMenu.subMenuRoutePath} element={allowedComponent[0].menuComponent}></Route>);
    }

    useEffect(() => {
        getSystemMenu();
    }, [])

    const NavBar = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-1 col-sm-1 col-md-3 col-lg-3 col-xl-3 col-xxl-3"></div>
                        <div className="col-10 col-sm-10 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <div className="row ">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center text-white">
                                    <h4>SAYUL MART</h4>
                                </div>
                            </div>

                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    <div className="dropdown">
                                        <button type="button" className="btn btn-dark form-control dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#fileMenu" aria-expanded="false" aria-controls="fileMenu">
                                            Sales
                                        </button>
                                        <div class="collapse mt-2" id="fileMenu">
                                            <div class="card card-body card__menu">
                                                {
                                                    fileMenu[0] && fileMenu[0].subMenuGrouped.map((grouped, groupedIndex) => (
                                                        <div key={groupedIndex}>
                                                            {
                                                                grouped.subMenu.map((subMenu) => (
                                                                    <p>
                                                                        <Link to={subMenu.subMenuLinkPath} className="dropdown-item card__menu--item">
                                                                            {subMenu.subMenuName}
                                                                        </Link>
                                                                    </p>
                                                                ))
                                                            }
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    <div className="dropdown">
                                        <button type="button" className="btn btn-dark dropdown-toggle form-control" data-bs-toggle="collapse" data-bs-target="#tranMenu" aria-expanded="false" aria-controls="tranMenu">
                                            Stock
                                        </button>
                                        <div class="collapse mt-2" id="tranMenu">
                                            <div class="card card-body card__menu">
                                                {
                                                    stockMenu[0] && stockMenu[0].subMenuGrouped.map((grouped, groupedIndex) => (
                                                        <div key={groupedIndex}>
                                                            {
                                                                grouped.subMenu.map((subMenu) => (
                                                                    <p>
                                                                        <Link to={subMenu.subMenuLinkPath} className="dropdown-item card__menu--item">
                                                                            {subMenu.subMenuName}
                                                                        </Link>
                                                                    </p>
                                                                ))
                                                            }
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    <button type="button" className="form-control btn btn-secondary" onClick={logOut}>Sign Out</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-1 col-sm-1 col-md-3 col-lg-3 col-xl-3 col-xxl-3"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <Routes>
                <Route path={"*"} element={<NavBar />}></Route>
                {
                    fileMenu[0] && fileMenu[0].subMenuGrouped.map((grouped) => (
                        grouped.subMenu.map((subMenu) => (renderRoute(subMenu, fileMenusComponent)))
                    ))
                }
                {
                    stockMenu[0] && stockMenu[0].subMenuGrouped.map((grouped) => (
                        grouped.subMenu.map((subMenu) => (renderRoute(subMenu, stockMenusComponent)))
                    ))
                }
            </Routes>
        </>
    );
}